import React from "react";
import { toast } from 'react-toastify';
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import './Modal.css';

const DeleteBoatModal = (props) => {

  const delayRefresh = () => {
    setTimeout(() => {
      window.location.reload(false);
    }, 2000);
  }

  const deleteBoatFromDatabase = () => {

    let boatOptions = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/deleteBoat',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        id: props.selectedRow[0].id
      })
    }
    const deleteBoat = async () =>{
      let response = await axios(boatOptions);
      toast.success("Successfully deleted boat. Please wait while table refreshes.")
    }
    deleteBoat();
    delayRefresh();
  }

  return (
    <>
      <div className="modal">
        <div onClick={props.toggleModal} className="overlay"></div>
        <div className="modal-content">
          <label>Are you sure you want to delete the selected boat? The associated anglers will remain in the system.</label><br/><br/>
          <button className="btn-modal" onClick={deleteBoatFromDatabase} type="button">Yes, Delete It</button>
          <button className="close-modal" onClick={props.toggleModal}>CLOSE</button>
        </div>
      </div>  
    </>
  );
}

export default DeleteBoatModal;

